<script>
    import { onMount } from "svelte";
import LoggedIn from "./Components/Auth/LoggedIn.svelte";
    import Customer from "./Components/Customer.svelte";
import Editor from "./Components/Helpers/Editor.svelte";
    import Medium from "./Components/Medium.svelte";
    import { options } from "./config";
    import { loading } from "./loader";
    import { GetContact, PostContact } from "./Services/form0";
    import { user } from "./store";

    let data = {
        "profile":options.profile,
        "form":"pir",
        data: {
            timeline:
                '<table class="medium-editor-table">\
    	<thead>\
          <tr>\
            <th style="width:50px">Time</th>\
          \
            <th  style="width:300px">Event/Action</th>\
          </tr>\
      </thead>\
      <tbody>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
        <tr><td></td><td></td></tr>\
      </tbody></table>',
            preventative:
                '<table class="medium-editor-table">\
    	<thead>\
          <tr>\
            <th style="width:50px">Owner</th><th style="width:50px">Action</th>\
            <th style="width:50px">Reference</th>\
            <th style="width:50px">Target Date</th><th style="width:50px">Status</th>\
          </tr>\
      </thead>\
      <tbody>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
        <tr><td></td><td></td><td></td><td></td><td></td></tr>\
      </tbody></table>',
        },
    };

    export let params = {};
    loading.set(true)
    onMount(() => {
        console.log(params.wild);
        let uuid = params.wild;
        if (params.wild) {
            GetContact(
                options.profile,
                uuid,
                $user.idToken,
                (d) => {
                    data = d;
                    loading.set(false)
                },
                (error) => {
                    console.error(error)
                    loading.set(false)
                }
            );
        }
        if(params.customer){
            data.data.customer = params.customer
            loading.set(false)
        }
    });

    const save = ()=>{
        loading.set(true)
        PostContact(data,$user.idToken,(d)=>{
            loading.set(false)
        },(error)=>{
            console.log(error)
            loading.set(false)
        })
    }
</script>
<LoggedIn/>
<div class="section_wrapper">
    <Customer bind:customer={data.data.customer}/>
    <div class="s s100 box">
        <div class="content_area">
            <form>
                <h1>Issue</h1>
                <div class="s s33">
                    <label>Date</label>
                    <input
                        placeholder="Issue Date"
                        type="date"
                        bind:value={data.data.incidentDate} />
                </div>
                <div class="s s33">
                    <label>Total Outage (minutes)</label>
                    <input
                        placeholder="Total outage in minutes"
                        type="number"
                        bind:value={data.data.totalOutageTime} />
                </div>
                <div class="s s33">
                    <label>Zendesk Ticket</label>
                    <input
                        placeholder="Zendesk ticket number"
                        type="text"
                        bind:value={data.data.zendeskReference} />
                </div>
                <div class="s s100">
                    <label>Title</label>
                    <input
                        type="text"
                        placeholder="Issue Title"
                        id="issue"
                        name="issue"
                        bind:value={data.data.issue} />
                </div>
                <div class="s s100">
                    <label>Description</label>
                    <textarea
                        placeholder="Issue Description"
                        cols="30"
                        rows="5"
                        bind:value={data.data.issueDescription} />
                </div>

                <div class="">
                    <label>End User Impact</label>
                    <textarea
                        placeholder="Issue Description"
                        cols="30"
                        rows="5"
                        bind:value={data.data.endUserImpact} />
                </div>
            </form>
        </div>
    </div>

    <div class="s s100 box">
        <div class="content_area">
            <form>
                <h1>Analysis</h1>
                <!-- <Editor bind:data={data.data.analysis}/> -->
                <Medium bind:data={data.data.analysis} name="analysis" />
            </form>
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area">
            <form>
                <h1>Root Cause</h1>
                <Medium bind:data={data.data.rootCause} name="rootcause" />
            </form>
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area">
            <form>
                <h1>Timeline</h1>
                <Medium bind:data={data.data.timeline} name="timeline" />
            </form>
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area">
            <form>
                <h1>Preventative Measures and Actions</h1>
                <Medium
                    bind:data={data.data.preventative}
                    name="preventative" />
            </form>
        </div> 
    </div>

    <div class="s s100 text_right">
        <h2>&nbsp;</h2>
        <div id="form_submit" on:click={save} class="brand-link">Save</div> <!-- add class "disabled" to disable interaction -->
    </div>
</div>
 